import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';

import { isSameDay } from 'utils/date';
import CustomSurveyReportApi from 'apis/reports/CustomSurveyReport';
import FeedbackList from './feedbackList';

class FeedbackReportDisplay extends Component {
  constructor() {
    super();
    this.state = {
      focusedInput: false,
      startDate: null,
      endDate: null,
      feedbacks: [],
    };
  }

  componentDidMount() {
    this.fetchReports();
  }

  fetchReports = () => {
    const { customSurveyId } = this.props;

    if (!customSurveyId) return;
    const { startDate, endDate } = this.state;
    const from = startDate ? moment(startDate).unix() : startDate;
    const to = endDate ? moment(endDate).unix() : endDate;
    CustomSurveyReportApi.getFeedbackReports(customSurveyId, from, to)
      .then(({ data }) => {
        this.setState({ feedbacks: data });
      })
      .catch(console.log);
  };

  renderDatePresets = () => {
    const { startDate, endDate } = this.props;
    const presets = [
      {
        text: 'This Week',
        start: moment().startOf('week'),
        end: moment().endOf('week'),
      },
      {
        text: 'Last Week',
        start: moment()
          .subtract(1, 'week')
          .startOf('week'),
        end: moment()
          .subtract(1, 'week')
          .endOf('week'),
      },
      {
        text: 'This Month',
        start: moment().startOf('month'),
        end: moment().endOf('month'),
      },
      {
        text: 'Last Month',
        start: moment()
          .subtract(1, 'month')
          .startOf('month'),
        end: moment()
          .subtract(1, 'month')
          .endOf('month'),
      },
    ];

    return (
      <div className="panel">
        {presets.map(({ text, start, end }) => {
          const isSelected =
            isSameDay(start, startDate) && isSameDay(end, endDate);
          return (
            <button
              key={text}
              type="button"
              className={`preset-btn ${isSelected ? 'selected' : ''}`}
              onClick={() => {
                this.onDateChange({ startDate: start, endDate: end });
                this.setState({ focusedInput: null });
              }}
            >
              {text}
            </button>
          );
        })}
      </div>
    );
  };

  onDateChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate }, () => this.fetchReportByDate());
  };

  fetchReportByDate = () => {
    const { startDate, endDate } = this.state;
    if ((startDate && endDate) || !(startDate || endDate)) this.fetchReports();
  };

  onFocusChange = focusedInput => {
    this.setState({ focusedInput });
  };

  render() {
    const { customSurveyId } = this.props;
    const { focusedInput, startDate, endDate, feedbacks } = this.state;
    const hasFeedbacks = feedbacks.length > 0;
    const dateDisplayStyle = hasFeedbacks ? '' : 'd-none';

    if (!customSurveyId) {
      return <div className="p-5 text-center w-100">
        Select a survey to view Feedback Reports
      </div>;
    }

    return (
      <React.Fragment>
        <div className={`row ${dateDisplayStyle}`}>
          <div className="d-flex align-items-center">
            <span className="font-weight-bold mr-1">Filter Dates:</span>
            <DateRangePicker
              small
              startDateId="startDate"
              endDateId="endDate"
              renderCalendarInfo={this.renderDatePresets}
              startDate={startDate}
              endDate={endDate}
              onDatesChange={this.onDateChange}
              focusedInput={focusedInput}
              isOutsideRange={dt => dt.isAfter(moment(), 'day')}
              onFocusChange={this.onFocusChange}
              showClearDates={startDate || endDate}
            />
          </div>
        </div>
        <div className="row">
          <FeedbackList feedbacks={feedbacks} />
        </div>
      </React.Fragment>
    );
  }
}

export default FeedbackReportDisplay;



// WEBPACK FOOTER //
// ./src/components/feedbackReport/reportDisplay.js